import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: RouteComponent,
  beforeLoad: () => {
    throw redirect({ to: "/plant-3/list" });
  },
});

function RouteComponent() {
  return (
    <div className="aero:opacity-20 aero:!text-center aero:h-full aero:flex aero:items-center aero:justify-center">
      <h1 className="aero:!text-4xl aero:!font-bold">
        Production Planning and Scheduling
      </h1>
    </div>
  );
}
